import React, { useState, useEffect } from 'react'
import { LeftOutlined } from "@ant-design/icons";
import { Formik, Field, FieldArray } from "formik";
import firebase from 'firebase'
import moment from 'moment'
import apolloclient from "../../../apollo_client";
import { GetUsersDetails } from '../../../Queries/User/EditUser'
import Loading from './../../../assets/images/loading.gif'
function BulkAppend({ CloseAppend }) {
    const [users, setUser] = useState([]);
    const [isloading, setisloading] = useState(true);
    useEffect(() => {
        firebase.firestore().collection('registered').get().then((querySnapshot) => {
            querySnapshot.docs.map(async doc => {
                let tempuser = doc.data()
                let newuser = {
                    email: tempuser.email,
                    clientid: tempuser.clientsid,
                    clientname: "",
                    birthdate: moment.date(tempuser.birthdate).format('YYYY-MM-DD'),
                    ecode: tempuser.ecode,
                    emailofficial: tempuser.email,
                    emailpersonal: tempuser.emailpersonal,
                    fleetsid: tempuser.fleetsid,
                    icao: tempuser.icao,
                    joindate: moment.date(tempuser.joindate).format('YYYY-MM-DD'),
                    managersid: tempuser.managersid,
                    department: "",
                    name: tempuser.name,
                    phone1: tempuser.phone1,
                    phone2: tempuser.phone2,
                    managername: "",
                    photo: tempuser.photo,
                    pmtaddress: tempuser.pmtaddress,
                    ranksid: tempuser.ranksid,
                    tempaddress: tempuser.tempaddress,
                    _optimiser: false,
                    _simulator: false,
                    _aircraft: false,
                    _crew: false,
                    _dataadmin: false,
                    _ground: false,
                    _manager: false,
                    active: true,
                    addresspmt: tempuser.pmtaddress,
                    addresstemp: tempuser.tempaddress,
                    adminactive: false,
                    adminapproved: true,
                    airactive: false,
                    aircraft: false,
                    approved: true,
                    base: tempuser.icao,
                    clientsid: tempuser.clientsid,
                    crew: false,
                    crewactive: false,
                    dataadmin: false,
                    ground: false,
                    groundactive: false,
                    joiningdate: moment.date(tempuser.joindate).format('YYYY-MM-DD'),
                    licence: tempuser.licence,
                    license: tempuser.licence,
                    manageactive: false,
                    managed: true,
                    manager: false,
                    optimactive: false,
                    optimiser: false,
                    pending: true,
                    rankid: tempuser.ranksid,
                    regactive: true,
                    roleallotted: false,
                    simactive: false,
                    simulator: false,
                    useractive: true,
                    fleetsname: ""
                }
                let response = await apolloclient.query({
                    query: GetUsersDetails,
                    variables: {
                        clientsid: newuser.clientsid,
                        managersid: newuser.managersid,
                        fleetsid: newuser.fleetsid
                    }
                })
                if (response.data?.aatmsv4_clients.length > 0) {
                    let querydata = response.data?.aatmsv4_clients[0];
                    newuser.clientname = querydata.clientname;
                    newuser.department = querydata.department;
                    if (querydata?.fleets.length > 0) {
                        newuser.fleetsname = querydata.fleets[0].aircraft;
                    }
                    if (querydata?.managers.length > 0) {
                        newuser.managername = querydata?.managers[0].managername
                    }
                    setUser((prevstate) => {
                        return [...prevstate, newuser]
                    })
                    setisloading(false)
                }
            });
        })
    }, [])
    return (
        <div>

            <div className="category-title">
                <span className="client-back" onClick={() => CloseAppend()}>
                    {<LeftOutlined />} USERS
        </span>
        Bulk Append
            </div>
            <div className="table-body-container">
                <div className="table-body-header">All Users</div>
                <div className="client-list-divider"></div>
                {
                    isloading ?
                        < img style={{ padding: 100 }} src={isloading ? Loading : null}
                            height="50%"
                            alt=""
                            width="50%"
                        />
                        : (
                            <Formik
                                initialValues={{ users }}
                                enableReinitialize
                                validate={() => ({ foo: true })}
                                onSubmit={(values, { setSubmitting }) => {
                                    setTimeout(() => {
                                        alert(JSON.stringify(values, null, 2));
                                    }, 500);
                                    setSubmitting(false)
                                }}>
                                {({ values }) => {
                                    return (<FieldArray name="users"
                                        render={arrayHelpers => {
                                            return (
                                                values.users && values.users.length > 0 && values.users.map((user, index) => (
                                                    <div className="table-container" key={index}>
                                                        <div className="table-row-container">
                                                            <div className="table-row-top">
                                                                <div className="items">
                                                                    <div className="title">Client</div>
                                                                    <div className="value">{user.clientname}</div>
                                                                </div>
                                                                <div className="items">
                                                                    <div className="title">Fleet</div>
                                                                    <div className="value">{user.fleetsname}</div>
                                                                </div>
                                                                <div className="items">
                                                                    <div className="title">Email</div>
                                                                    <div className="value">{user.email}</div>
                                                                </div>
                                                                <div>
                                                                    <button className="submit-button" onClick={(event, index) => {
                                                                        setisloading(true)
                                                                        let createNewUser = firebase.functions().httpsCallable('adminCreateUser');
                                                                        user.regactive = user.useractive = user.active;
                                                                        user._optimiser = user.optimactive = user.optimiser;
                                                                        user._simulator = user.simactive = user.simulator;
                                                                        user._aircraft = user.airactive = user.aircraft;
                                                                        user._crew = user.crewactive = user.crew;
                                                                        user._dataadmin = user.adminactive = user.dataadmin;
                                                                        user._ground = user.groundactive = user.ground;
                                                                        user._manager = user.manageactive = user.manager;
                                                                        let strImage = user.photo.replace(/^data:image\/[a-z]+;base64,/, "");
                                                                        let imagetype = user.photo.split(';')[0].split(':')[1];
                                                                        firebase.storage().ref(`/${user.clientname}/profile pictures/`).child(`${user.email}`)
                                                                            .putString(strImage, "base64", { contentType: imagetype }).then(snapshot => {
                                                                                snapshot.ref.getDownloadURL().then(photourl => {
                                                                                    user.photo = photourl;
                                                                                    console.log({ user: user })
                                                                                    createNewUser({ user: user })
                                                                                        .then(() => {
                                                                                            console.log("User creation Successfull!!");
                                                                                            firebase.firestore().collection('registered').where("email", "==", user.email).get().then(function (querySnapshot) {
                                                                                                querySnapshot.forEach(function (doc) {
                                                                                                    doc.ref.delete();
                                                                                                    arrayHelpers.remove(index);
                                                                                                    setisloading(false)
                                                                                                    alert("User has been Added Successfully");
                                                                                                });
                                                                                            });
                                                                                        })
                                                                                        .catch(err => {
                                                                                            console.log(`Error Occured!! ${err}`);
                                                                                        })
                                                                                })
                                                                            })
                                                                    }
                                                                    }>Approve</button>
                                                                </div>
                                                            </div>
                                                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', margin: '6px 3px' }}>
                                                                <Field type="checkbox" className="userAuth" name={`users.${index}.active`} /> Active
                                                    <Field type="checkbox" className="userAuth" name={`users.${index}.ground`} />   Ground
                                                    <Field type="checkbox" className="userAuth" name={`users.${index}.simulator`} />   Simulator
                                                    <Field type="checkbox" className="userAuth" name={`users.${index}.aircraft`} />   Aircraft
                                                    <Field type="checkbox" className="userAuth" name={`users.${index}.crew`} />   Crew
                                                    <Field type="checkbox" className="userAuth" name={`users.${index}.manager`} />   Manager
                                                    <Field type="checkbox" className="userAuth" name={`users.${index}.optimiser`} />   Optimiser
                                                    <Field type="checkbox" className="userAuth" name={`users.${index}.dataadmin`} />   DataAdmin
                                                     </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )
                                        }} />)
                                }}
                            </Formik>

                        )
                }
            </div>
        </div >
    )
}
export default BulkAppend
